// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2fAW_","title":"ClientInsurance_title__3E9Br","itemText":"ClientInsurance_itemText__1Nk5a"};